<template>
  <div class="page">
    <div class="banner">
      <!--<img class="banner" src="@/assets/img/case/banner.png" />-->
    </div>
    <div class="content">
      <side-nav :navs="navs" :active="active" @change-nav="changeNav">
        <side-nav-content
          :bread="['产品案例', '自有产品']"
          v-show="active === 0"
        >
          <!--案例切换-->
          <div class="select">
            <a
              v-for="(product, index) in products"
              :key="product.id"
              @click="changeCase('updateProductsIndex', index)"
              :class="index === productsIndex ? 'active' : ''"
            >
              {{ product.name }}
            </a>
          </div>
          <!--专用超声波传感芯片与设备-->
          <div class="caseContent" v-show="active === 0 && productsIndex === 0">
            <p class="caseTitle">专用超声波传感芯片与设备</p>
            <P class="caseIntro"
              >瞄准水利行业应用，进行基于<span>超声波传感器</span>的新产品研发</P
            >
            <div class="caseOne">
              <div
                v-for="caseOne in caseOnes"
                :key="caseOne.id"
                class="caseBox"
              >
                <img :src="caseOne.img" />
                <p>{{ caseOne.name }}</p>
              </div>
            </div>
          </div>
          <!--窄带低功耗安全通信芯片与模组-->
          <div class="caseContent" v-show="active === 0 && productsIndex === 1">
            <p class="caseTitle">窄带低功耗安全通信芯片与模组</p>
            <P class="caseIntro"
              >解决当前物联网应用<span>“重功能、轻安全”</span>的问题，研发安全协议、安全芯片，与低功耗通信芯片一体化封装。
            </P>
            <div class="caseTwo">
              <div class="caseTwoCon">
                <div v-for="caseTwo in caseTwos" v-bind:key="caseTwo.id">
                  <p class="title">{{ caseTwo.title }}</p>
                  <p class="titleSec">{{ caseTwo.titleSec }}</p>
                  <p class="info">{{ caseTwo.info }}</p>
                </div>
              </div>
              <img src="../assets/img/case/case-2/img.png" />
            </div>
          </div>
          <!--专用SIP一体化封装技术与芯片-->
          <div class="caseContent" v-show="active === 0 && productsIndex === 2">
            <p class="caseTitle">专用SIP一体化封装技术与芯片</p>
            <p class="caseIntro">
              提升感知设备的<span>可靠性，降低功耗，</span>对传感传输模块一体化封装。
            </p>
            <div class="caseThree">
              <img src="../assets/img/case/case-3/img.png" />
            </div>
          </div>
          <!--多参数水质分析传感器-->
          <div class="caseContent" v-show="active === 0 && productsIndex === 3">
            <p class="caseTitle">多参数水质分析传感器</p>
            <p class="caseIntro">
              采用低功耗算法上报各监测点多参数水质数据，可测得
            </p>
            <div class="caseFour">
              <div class="left">
                <div class="caseFourCon">
                  <div
                    class="caseFourBox"
                    v-for="caseFour in caseFours"
                    v-bind:key="caseFour.id"
                  >
                    <img :src="caseFour.img" />
                    <p class="name">{{ caseFour.name }}</p>
                  </div>
                </div>
                <p>
                  可用于水源地、水库、河流、海洋监测；污染企业监测；洪涝灾害应急防灾监测。
                </p>
              </div>
              <div class="rightImg">
                <img src="../assets/img/case/case-4/img.png" />
              </div>
            </div>
          </div>
          <!--水雨情传感监测技术与设备-->
          <div class="caseContent" v-show="active === 0 && productsIndex === 4">
            <p class="caseTitle">水雨情传感监测技术与设备</p>
            <p class="caseIntro">
              瞄准中小水库治理、水土保持、防洪应用需求，研发<span>“水、土、气、生”</span>综合监测传感器与设备
            </p>
            <div class="caseFive">
              <div
                class="caseFiveBox"
                v-for="caseFive in caseFives"
                v-bind:key="caseFive.id"
              >
                <img :src="caseFive.img" />
                <div class="text">
                  <p class="name">{{ caseFive.name }}</p>
                  <p class="info">{{ caseFive.info }}</p>
                </div>
              </div>
            </div>
          </div>
          <!--宽带多跳MESH专网通信技术与设备-->
          <div class="caseContent" v-show="active === 0 && productsIndex === 5">
            <p class="caseTitle">宽带多跳MESH专网通信技术与设备</p>
            <p class="caseIntro">
              瞄准水利应急、督察、防洪等应用中远程宽带通信需求，研发宽带多跳MESH一体化的专网技术与设备
            </p>
            <div class="caseSix">
              <img src="../assets/img/case/case-6/img.png" />
            </div>
          </div>
        </side-nav-content>
        <side-nav-content
          :bread="['产品案例', '解决方案']"
          v-show="active === 1"
        >
          <!--解决方案切换-->
          <div class="select">
            <a
              v-for="(solution, index) in solutions"
              v-bind:key="solution.id"
              :class="solutionsIndex === index ? 'active' : ''"
              @click="changeCase('updateSolutionsIndex', index)"
            >
              {{ solution.name }}
            </a>
          </div>
          <!--前端信息智能处理算法研发 -->
          <div
            class="caseContent"
            v-show="active === 1 && solutionsIndex === 0"
          >
            <p class="caseTitle">前端信息智能处理算法研发</p>
            <p class="caseIntro">
              通过对多来源、多类型异构感知信息，需要进行预处理、数据融合、特征提取等，以<span
                >保证前端感知数据的准确性、异常模式判定的可靠性</span
              >
            </p>
            <div class="caseSeven">
              <img src="../assets/img/case/case-7/img.png" />
            </div>
          </div>
          <!--河(湖)长制设备与解决方案-->
          <div
            class="caseContent"
            v-show="active === 1 && solutionsIndex === 1"
          >
            <p class="caseTitle">河(湖)长制设备与解决方案</p>
            <p class="caseIntro">
              研发自主知识产权<span
                >水质监测传感器与系统，提升可靠性，降低成本</span
              >
            </p>
            <div class="caseEight">
              <img src="../assets/img/case/case-8/img.png" />
            </div>
          </div>
          <!--井盖监控系统-->
          <div
            class="caseContent"
            v-show="active === 1 && solutionsIndex === 2"
          >
            <p class="caseTitle">井盖监控系统</p>
            <P class="caseIntro"
              >通过光敏和超声波测距判断井盖开闭状态；通过监测井下水位的变化来判断是否堵塞或积水；通过超声波来判断井内燃气泄漏与否；
              基于NB-IOT的监控管理平台，完成井盖的管理，报警事件处理、巡查、派工等综合服务。通过NB-IOT进行数据发送及报警，手机、平台实时同步
              监测数据与告警信息。</P
            >
            <div class="caseNine">
              <div class="left">
                <p class="name">可运用于</p>
                <div class="leftCon">
                  <div
                    class="leftBox"
                    v-for="caseNine in caseNines"
                    v-bind:key="caseNine.id"
                  >
                    <img :src="caseNine.img" />
                    <p>{{ caseNine.name }}</p>
                  </div>
                </div>
              </div>
              <div class="right">
                <img src="../assets/img/case/case-9/img.png" />
              </div>
            </div>
          </div>
          <!--径流一体化监测系统-->
          <div
            class="caseContent"
            v-show="active === 1 && solutionsIndex === 3"
          >
            <P class="caseTitle">径流一体化监测系统</P>
            <p class="caseIntro">
              系统由云端监测管理系统和前端的径流一体化传感器及地面径流场传感器组成，是适用于野外各种径流含沙量、流速和水位的新型自动监测系统，
              应用于山洪灾害易发区的河流实时预警，大坝或一般河流水体的固定观测，水土保持小流域控制站和坡面径流场的在线监测，可同时获得含沙量、
              流速、水位变化、降雨量和土壤湿度的过程曲线。
            </p>
            <div class="caseTen">
              <div class="left">
                <p>设备操作简单，可自适应组网，支持</p>
                <div class="leftCon">
                  <div>NB-IOT</div>
                  <div>GPRS</div>
                  <div>Lora组网传输</div>
                </div>
                <p>
                  采样间隔可自适应或手动设置，在线实时测量、存储多种传感器参数值。
                </p>
              </div>
              <div class="right">
                <img src="../assets/img/case/case-10/img.png" />
              </div>
            </div>
          </div>
          <!--水质监测数据记录方案-->
          <div
            class="caseContent"
            v-show="active === 1 && solutionsIndex === 4"
          >
            <P class="caseTitle">水质监测数据记录方案</P>
            <p class="caseIntro">
              将无线传感网数据向水质数据区块链网络上传，实现基于区块链技术的水质监测数据记录方案，可满足监测数据机密性、完整性、共享性、可用性
              的数据记录要求。
            </p>
            <div class="caseEleven">
              <div class="left">
                <P>方案特点</P>
                <div class="leftBox">自组织传感网络区块链网络中的角色；</div>
                <div class="leftBox">匹配水质监测的时间同步服务器设置；</div>
                <div class="leftBox">特殊的区块数据交易结构；</div>
                <div class="leftBox">
                  基于PoS的共识机制以及记录数据分层共享机制；
                </div>
                <div class="leftBox">水质监测数据的加密搜索实现。</div>
              </div>
              <div class="right">
                <img src="../assets/img/case/case-11/img.png" />
              </div>
            </div>
          </div>
          <!--物联网云平台-->
          <div
            class="caseContent"
            v-show="active === 1 && solutionsIndex === 5"
          >
            <p class="caseTitle">物联网云平台</p>
            <p class="caseIntro">
              物联网云平台为设备提供安全可靠的连接通信能力，向下连接海量设备，支撑设备数据采集上云；向上提供云端API，服务端通过调用云端API将指
              令下发至设备端，实现远程控制。物联网平台也提供了其他增值能力，如设备管理、规则引擎、数据分析、边缘计算等，为各类IOT场景和行业开
              发者赋能。
            </p>
            <div class="caseTwelve">
              <div class="left">
                <div class="leftBox">
                  <img src="../assets/img/case/case-12/icon-1.png" />
                  <p>智慧城市</p>
                </div>
                <div class="leftBox">
                  <img src="../assets/img/case/case-12/icon-2.png" />
                  <p>智慧农业</p>
                </div>
                <div class="leftBox">
                  <img src="../assets/img/case/case-12/icon-3.png" />
                  <p>安全监控物联网</p>
                </div>
                <div class="leftBox">
                  <img src="../assets/img/case/case-12/icon-4.png" />
                  <p>工业4.0</p>
                </div>
              </div>
              <div class="right">
                <img src="../assets/img/case/case-12/img.png" />
              </div>
            </div>
          </div>
          <!--融合通信解决方案-->
          <div
            class="caseContent"
            v-show="active === 1 && solutionsIndex === 6"
          >
            <p class="caseTitle">融合通信解决方案</p>
            <p class="caseIntro">
              提供NB-IOT/4G/LORA/卫星的融合通信。自动选择相应的上行传输通道。根据优先级适配上行传输通道。IP65防水，满足野外恶劣环境应用。
              手机、平台同步显示、告警。
            </p>
            <div class="caseEleven">
              <div class="left">
                <P>可运用于</P>
                <div class="leftBox">偏远地区水库大坝安全监测预警。</div>
                <div class="leftBox">森林安全监测预警；</div>
                <div class="leftBox">特殊的区块数据交易结构；</div>
                <div class="leftBox">智慧农业及水利应用；</div>
                <div class="leftBox">水保站点智慧化监测。</div>
              </div>
              <div class="right">
                <img src="../assets/img/case/case-13/img.png" />
              </div>
            </div>
          </div>
        </side-nav-content>
        <side-nav-content
          :bread="['产品案例', '成功案例']"
          v-show="active === 2"
        >
          <!--成功案例切换-->
          <div class="select">
            <a
              v-for="(caseSucc, index) in caseSuccs"
              v-bind:key="caseSucc.id"
              @click="changeCase('updateCaseSuccsIndex', index)"
              :class="index === caseSuccsIndex ? 'active' : ''"
            >
              {{ caseSucc.name }}</a
            >
          </div>
          <!--水利物联网-->
          <div
            class="caseContent"
            v-show="active === 2 && caseSuccsIndex === 0"
          >
            <P class="caseTitle">水利物联网</P>
            <p class="caseIntro">
              在九大业务和水利监督业务各自提出的纵向建设需求基础上，根据互联互通、信息共享和业务协同的原则，按照建设需求性质，从信息获取、数据
              资源、业务应用、安全保障等层面进行横向整合和打通，为避免重复建设、提高复用率等奠定基础。
            </p>
            <div class="caseFourteen">
              <img class="big" src="../assets/img/case/case-14/img.png" />
              <div class="caseCon">
                <div class="caseBox">
                  <img src="../assets/img/case/case-14/img-1.png" />
                  <p>构建天空地一体化水利感知网</p>
                </div>
                <div class="caseBox">
                  <img src="../assets/img/case/case-14/img-2.png" />
                  <p>完善全面互联高速可靠的水利信息网</p>
                </div>
                <div class="caseBox">
                  <img src="../assets/img/case/case-14/img-3.png" />
                  <p>建设智慧水利大脑</p>
                </div>
                <div class="caseBox">
                  <img src="../assets/img/case/case-14/img-4.png" />
                  <p>构建创新协同的智能应用</p>
                </div>
                <div class="caseBox">
                  <img src="../assets/img/case/case-14/img-5.png" />
                  <p>提升网络安全威胁感和应急处置能力</p>
                </div>
              </div>
            </div>
          </div>
        </side-nav-content>
      </side-nav>
    </div>
  </div>
</template>

<script>
import SideNav from "../components/sideNav";
import SideNavContent from "../components/sideNavContent";
import caseImgUrl1 from "../assets/img/case/case-1/img1.png";
import caseImgUrl2 from "../assets/img/case/case-1/img2.png";
import caseImgUrl3 from "../assets/img/case/case-1/img3.png";
import caseImgUrl4 from "../assets/img/case/case-1/img4.png";
import caseImgUrl5 from "../assets/img/case/case-1/img5.png";
import caseImgUrl6 from "../assets/img/case/case-1/img6.png";
import icon1 from "../assets/img/case/case-4/icon-1.png";
import icon2 from "../assets/img/case/case-4/icon-2.png";
import icon3 from "../assets/img/case/case-4/icon-3.png";
import icon4 from "../assets/img/case/case-4/icon-4.png";
import icon5 from "../assets/img/case/case-4/icon-5.png";
import icon6 from "../assets/img/case/case-4/icon-6.png";
import caseFiveImg1 from "../assets/img/case/case-5/img-1.png";
import caseFiveImg2 from "../assets/img/case/case-5/img-2.png";
import caseNineImg1 from "../assets/img/case/case-9/icon-1.png";
import caseNineImg2 from "../assets/img/case/case-9/icon-2.png";
import caseNineImg3 from "../assets/img/case/case-9/icon-3.png";
import caseNineImg4 from "../assets/img/case/case-9/icon-4.png";
export default {
  name: "case",
  components: {
    SideNav,
    SideNavContent
  },
  data() {
    return {
      navs: [
        { id: 1, name: "自有产品" },
        { id: 2, name: "解决方案" },
        { id: 3, name: "成功案例" }
      ],
      // 自有产品标题
      products: [
        { id: 1, name: "专用超声波传感芯片与设备" },
        { id: 2, name: "窄带低功耗安全通信芯片与模组" },
        { id: 3, name: "专用SIP一体化封装技术与芯片" },
        { id: 4, name: "多参数水质分析传感器" },
        { id: 5, name: "水雨情传感监测技术与设备" },
        { id: 6, name: "宽带多跳MESH专网通信技术与设备" }
      ],
      // 解决方案标题
      solutions: [
        { id: 1, name: "前端信息智能处理算法研发  " },
        { id: 2, name: "河(湖)长制设备与解决方案  " },
        { id: 3, name: "井盖监控系统 " },
        { id: 4, name: "径流一体化监测系统  " },
        { id: 5, name: "水质监测数据记录方案   " },
        { id: 6, name: "物联网云平台" },
        { id: 7, name: "融合通信解决方案   " }
      ],
      // 成功案例
      caseSuccs: [{ id: 1, name: "水利物联网" }],
      // 专用超声波传感芯片与设备
      caseOnes: [
        {
          id: 1,
          name: "超声波AFE芯片",
          img: caseImgUrl1
        },
        {
          id: 2,
          name: "超声波测距仪",
          img: caseImgUrl2
        },
        {
          id: 3,
          name: "超声波水表",
          img: caseImgUrl3
        },
        {
          id: 4,
          name: "超声波水位计",
          img: caseImgUrl4
        },
        {
          id: 5,
          name: "超声波流速计",
          img: caseImgUrl5
        },
        {
          id: 6,
          name: "超声波流量计",
          img: caseImgUrl6
        }
      ],
      // 窄带低功耗安全通信芯片与模组
      caseTwos: [
        {
          id: 1,
          title: "应用",
          titleSec: "",
          info:
            "·UDP应用服务器，与终端数据交互。\n" +
            "·数据库服务，存储终端数据\n" +
            "·Web服务器，手机APP"
        },
        {
          id: 2,
          title: "软件",
          titleSec: "指令集和MPSoC开发",
          info:
            "·射频仿真与在环验证。\n" +
            "·通信规约设计 \n" +
            "·分层模块化设计 \n" +
            " ·低功耗设计 "
        },
        {
          id: 3,
          title: "硬件",
          titleSec: "NB-loT/mcu/SoC/Sim/eSim",
          info:
            "·大道至简，高度集成与稳定的架构。\n" +
            "·主设计，2大版本8小版本迭代 \n" +
            "·沉金工艺，大厂代工 \n" +
            "·村田电阻电容，福晶原厂晶振  "
        }
      ],
      // 多参数水质分析传感器
      caseFours: [
        {
          id: 1,
          name: "Ph",
          img: icon1
        },
        {
          id: 2,
          name: "水温",
          img: icon2
        },
        {
          id: 3,
          name: "电导率",
          img: icon3
        },
        {
          id: 4,
          name: "余氯",
          img: icon4
        },
        {
          id: 5,
          name: "溶解氧",
          img: icon5
        },
        {
          id: 6,
          name: "化学需氧量",
          img: icon5
        },
        {
          id: 7,
          name: "浊度",
          img: icon6
        }
      ],
      // 水雨情传感监测技术与设备
      caseFives: [
        {
          id: 1,
          name: "径流一体化传感器  ",
          info:
            "集传感、采集、汇聚和传输于一体的综合传感器模组，用来采集径流水域水位、流速、含沙量等信息，有功耗低、体积小、自组网、易维护等特",
          img: caseFiveImg1
        },
        {
          id: 2,
          name: "墒情雨量一体传感器",
          info:
            "通过含水率探测传感器与采集传输设备，对监测环境下地表土壤含水率和土壤温湿度进行监测，可为山洪预警与长期态势发展预测提供依据 ",
          img: caseFiveImg2
        }
      ],
      // 井盖监控系统
      caseNines: [
        {
          id: 1,
          name: "城市燃气管道窨井监控  ",
          img: caseNineImg1
        },
        {
          id: 1,
          name: "城市污水管道窨井监控  ",
          img: caseNineImg2
        },
        {
          id: 1,
          name: "城市通讯管道窨井监控  ",
          img: caseNineImg3
        },
        {
          id: 1,
          name: "城市电力管道窨井监控  ",
          img: caseNineImg4
        }
      ]
    };
  },
  computed: {
    productsIndex() {
      return this.$store.state.productsIndex;
    },
    solutionsIndex() {
      return this.$store.state.solutionsIndex;
    },
    caseSuccsIndex() {
      return this.$store.state.caseSuccsIndex;
    },
    active() {
      return this.$store.state.caseActive;
    }
  },
  methods: {
    changeNav(index) {
      this.$store.commit("updateCaseActive", index);
    },
    changeCase(str, index) {
      this.$store.commit(str, index);
    }
  }
};
</script>

<style scoped>
@import "../assets/css/main.css";
.banner {
  width: 100%;
  height: 321px;
  background: url("../assets/img/case/banner.png") center no-repeat;
  margin-bottom: 40px;
}
.select {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 10px;
  border-bottom: 1px solid #f1f5f7;
}
.select a {
  display: flex;
  background: rgba(246, 246, 246, 1);
  font-size: 16px;
  color: rgba(61, 61, 61, 1);
  line-height: 40px;
  padding: 0 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.select a:hover {
  background: rgba(238, 249, 255, 1);
  color: #0588cd;
}
.select a.active {
  background: rgba(238, 249, 255, 1);
  color: #0588cd;
}
.caseContent {
  margin-top: 20px;
}
.caseContent .caseTitle {
  font-size: 30px;
  font-weight: bold;
  color: rgba(39, 39, 39, 1);
  line-height: 60px;
}
.caseContent .caseIntro {
  font-size: 18px;
  line-height: 30px;
  margin-bottom: 20px;
}
.caseContent .caseIntro span {
  color: #0588cd;
}
.caseOne {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.caseOne .caseBox {
  padding: 10px;
  border: 1px solid #f1f5f7;
  border-radius: 10px;
  margin-bottom: 20px;
}
.caseOne .caseBox img{
  width: 300px;
}
.caseOne p {
  font-size: 18px;
  line-height: 24px;
  margin: 10px 0;
}
.caseTwo {
  margin-bottom: 20px;
}
.caseTwo .caseTwoCon {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.caseTwo .caseTwoCon div {
  width: 320px;
  padding: 15px;
  box-sizing: border-box;
  border-radius: 10px;
  border: 1px solid #f1f5f7;
}
.caseTwo .caseTwoCon div .title {
  font-size: 18px;
  color: #0588cd;
  line-height: 24px;
  margin-bottom: 10px;
}
.caseTwo .caseTwoCon div .titleSec {
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
}
.caseTwo .caseTwoCon div .info {
  font-size: 18px;
  line-height: 24px;
}
.caseThree img {
  margin: 20px 0;
}
.caseFour {
  display: flex;
  justify-content: space-between;
  width: 1000px;
  margin-bottom: 20px;
}
.caseFour .caseFourCon {
  display: flex;
  margin-bottom: 20px;
}
.caseFour .caseFourCon .caseFourBox {
  width: 86px;
  box-sizing: border-box;
  border: 1px solid #f1f5f7;
  border-radius: 6px;
  margin-right: 10px;
  text-align: center;
  padding: 15px 0;
}
.caseFour .caseFourCon .caseFourBox img {
  margin-bottom: 10px;
}
.caseFour .caseFourCon .caseFourBox p {
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
}
.caseFive {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.caseFive .caseFiveBox {
  width: 480px;
  padding: 15px;
  box-sizing: border-box;
  border: 1px solid #f1f5f7;
  border-radius: 6px;
  display: flex;
}
.caseFive .caseFiveBox img {
  margin-right: 15px;
}
.caseFive .caseFiveBox .name {
  font-size: 18px;
  font-weight: bold;
  line-height: 30px;
  margin-bottom: 20px;
}
.caseFive .caseFiveBox .info {
  font-size: 18px;
  line-height: 24px;
}
.caseSeven {
  margin: 20px 0;
}
.caseEight {
  margin: 20px 0;
}
.caseNine {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.caseNine .left .name {
  font-size: 18px;
  font-weight: bold;
  line-height: 30px;
  margin-bottom: 20px;
}
.caseNine .left .leftCon {
  display: flex;
  width: 560px;
  flex-wrap: wrap;
}
.caseNine .left .leftCon .leftBox {
  width: 260px;
  height: 50px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  padding-left: 10px;
  margin: 0 20px 20px 0;
  border: 1px solid #f1f5f7;
  border-radius: 6px;
}
.caseNine .left .leftCon .leftBox img {
  margin-right: 15px;
}
.caseNine .left .leftCon .leftBox p {
  font-size: 18px;
}
.caseNine .right {
  padding-top: 50px;
}
.caseTen {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.caseTen .left p {
  font-size: 18px;
  line-height: 30px;
}
.caseTen .left .leftCon {
  display: flex;
  margin: 20px 0;
}
.caseTen .left .leftCon div {
  width: 160px;
  height: 50px;
  border: 1px solid #f1f5f7;
  border-radius: 6px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
  line-height: 50px;
  margin-right: 20px;
}
.caseEleven {
  display: flex;
  margin: 20px 0;
  justify-content: space-between;
}
.caseEleven .left p {
  font-size: 18px;
  font-weight: bold;
  line-height: 30px;
  margin-bottom: 20px;
}
.caseEleven .left .leftBox {
  width: 530px;
  height: 50px;
  border: 1px solid #f1f5f7;
  border-radius: 6px;
  box-sizing: border-box;
  padding-left: 15px;
  /*text-align: center;*/
  font-size: 18px;
  line-height: 50px;
  margin-bottom: 20px;
}
.caseTwelve {
  display: flex;
  margin: 20px 0;
  justify-content: space-between;
}
.caseTwelve .left {
  display: flex;
}
.caseTwelve .left .leftBox {
  width: 130px;
  height: 180px;
  border: 1px solid #f1f5f7;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 15px;
  text-align: center;
  font-size: 18px;
  line-height: 50px;
  margin-bottom: 20px;
  margin-right: 10px;
}
.caseTwelve .left .leftBox img {
  margin-top: 20px;
}
.caseTwelve .left .leftBox p {
  font-size: 18px;
  line-height: 24px;
}
.caseFourteen {
  margin: 20px 0;
}
.caseFourteen .big {
  margin-bottom: 20px;
}
.caseFourteen .caseCon {
  width: 1000px;
  display: flex;
  justify-content: space-between;
}
.caseFourteen .caseCon .caseBox {
  width: 180px;
  height: 200px;
  border: 1px solid #f1f5f7;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 15px;
}
.caseFourteen .caseCon .caseBox img {
  margin-bottom: 15px;
  width: 150px;
}
.caseFourteen .caseCon .caseBox p {
  font-size: 18px;
  line-height: 24px;
}
</style>
